import echarts from '@/config/echarts/index.js'
export function getWaterloggingOption (option) {
  return {
    color: ['#46C8FF', '#46C8FF', '#46C8FF', '#46C8FF'],
    grid: {
      left: 50,
      right: 30,
      top: 30,
      bottom: 30
    },
    legend: {
      show: true,
      textStyle: {
        color: '#FFF'
      }
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem'
      },
      data: ['当月', '龙舟水', '同比', '当年', '常年']
    },
    yAxis: [
      {
        type: 'value',
        name: '水位',
        position: 'left',
        offset: 10,
        nameTextStyle: {
          fontSize: '0.9rem',
          align: 'right',
          color: '#FFF'
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      },
      {
        type: 'value',
        name: '雨量',
        position: 'right',
        offset: -50,
        nameTextStyle: {
          fontSize: '0.9rem',
          align: 'left',
          color: '#FFF'
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      },
      {
        type: 'value',
        name: '积水',
        position: 'right',
        offset: 0,
        nameTextStyle: {
          fontSize: '0.9rem',
          align: 'left',
          color: '#FFF'
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      }
    ],
    series: [
      {
        name: '雨量',
        data: [12, 7, 17, 13, 25],
        type: 'bar',
        barWidth: 24,
        yAxisIndex: 1

      },
      {
        name: '水位',
        data: [12, 7, 17, 13, 25],
        type: 'line',
        barWidth: 24,
        showSymbol: false,
        smooth: true,
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(114, 223, 255, 0.50)'
            },
            {
              offset: 1,
              color: 'rgba(0, 179, 255, 0)'
            }
          ])
        }
      },

      {
        name: '积水',
        data: [15, 8, 10, 11, 22],
        type: 'line',
        barWidth: 24,
        yAxisIndex: 2,
        smooth: true,
        showBackground: true,
        backgroundStyle: {
          color: 'rgba(31, 44, 73, 0.87)',
          borderRadius: 10
        },
        itemStyle: {
          normal: {
            borderRadius: [10, 10, 0, 0],
            color: function (params) {
              const color = {
                type: 'linear',
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#2D74F5'
                  },
                  {
                    offset: 1,
                    color: '#53A4FA'
                  }
                ],
                global: false
              }
              const color1 = {
                type: 'linear',
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#FFA32B'
                  },
                  {
                    offset: 1,
                    color: '#FFC673'
                  }
                ],
                global: false
              }
              return params.dataIndex % 2 === 0 ? color : color1
            }
          }
        }
      }
    ]
  }
}
